import { createBrowserRouter } from "react-router-dom";
import { DashboardView } from "../../pages/dashboard";
import { Clienti } from "../../pages/clienti";
import { NewCliente } from "../../pages/clienti/newCliente";
import { EditCustomer } from "../../pages/clienti/editCustomer";
import { GestionePersonale } from "../../pages/gestionePersonale";
import { Formazione } from "../../pages/gestionePersonale/formazione";
import { NewTraining } from "../../pages/gestionePersonale/boxFormazione/newFormazione";
import { EditTraining } from "../../pages/gestionePersonale/boxFormazione/editFormazione";
import { GestioneDocumenti } from "../../pages/gestioneDocumenti";
import { PageNotFound } from "../../pages/pageNotFound";
import { DepartureProtocol } from "../../pages/protocol/departure";
import { CartellaAziendale } from "../../pages/cartellaAziendale";
import { ComplianceRequests } from "../../pages/gestioneCertificazione/complianceRequests";
import { AddComplianceRequest } from "../../pages/gestioneCertificazione/complianceRequests/add";
import { EditRequestComplianceRequest } from "../../pages/gestioneCertificazione/complianceRequests/edit";
import { RegistriAziendali } from "../../pages/gestioneClienti/registriAziendali";
import { AddRegistroAziendale } from "../../pages/gestioneClienti/registriAziendali/add";
import { EditRegistroAziendale } from "../../pages/gestioneClienti/registriAziendali/edit";
import { ReportRegistriAziendali } from "../../pages/gestioneClienti/registriAziendali/report";
import { RID } from "../../pages/gestioneClienti/RID";
import { AddRID } from "../../pages/gestioneClienti/RID/addRID";
import { EditRID } from "../../pages/gestioneClienti/RID/editRID";
import { Liberatorie } from "../../pages/gestioneControllo/liberatorie";
import { PAC } from "../../pages/gestioneControllo/pac";
import { AddPAC } from "../../pages/gestioneControllo/pac/addPac";
import { EditPAC } from "../../pages/gestioneControllo/pac/editPac";
import { PeriodoConversione } from "../../pages/gestioneControllo/periodoConversione";
import { PeriodoConversioneAdd } from "../../pages/gestioneControllo/periodoConversione/add";
import { PeriodoConversioneEdit } from "../../pages/gestioneControllo/periodoConversione/edit";
import { Segnalazioni } from "../../pages/gestioneControllo/segnalazioni";
import { AddReporting } from "../../pages/gestioneControllo/segnalazioni/addReporting";
import { EditReporting } from "../../pages/gestioneControllo/segnalazioni/editReporting";
import { EditStaff } from "../../pages/gestionePersonale/editStaff";
import { NewStaff } from "../../pages/gestionePersonale/NewStaff";
import { GestionePrelieviForAll } from "../../pages/gestionePrelievi";
import { CustomerMeasueres } from "../../pages/gestioneProvvedimenti/measures";
import { AddNewCodexMeasureStep1 } from "../../pages/gestioneProvvedimenti/measures/addNew/Step1";
import { AddNewCodexMeasureStep2 } from "../../pages/gestioneProvvedimenti/measures/addNew/Step2";
import { EditCodexMeasure } from "../../pages/gestioneProvvedimenti/measures/edit";
import { AddNewCodexMeasureOtherOdc } from "../../pages/gestioneProvvedimenti/measuresOtherOdc/add";
import { EditCodexMeasureOtherOdc } from "../../pages/gestioneProvvedimenti/measuresOtherOdc/edit";
import { ReinforcedControlMeasure } from "../../pages/gestioneProvvedimenti/reinforcedControlMeasure";
import { AddReinforcedControlMeasure } from "../../pages/gestioneProvvedimenti/reinforcedControlMeasure/add";
import { EditReinforcedControlMeasure } from "../../pages/gestioneProvvedimenti/reinforcedControlMeasure/edit";
import { AddDepartureProtocol } from "../../pages/protocol/departure/add";
import { EditDepartureProtocol } from "../../pages/protocol/departure/edit";
import { EntryProtocol } from "../../pages/protocol/entry";
import { AddEntryProtocol } from "../../pages/protocol/entry/add";
import { EditEntryProtocol } from "../../pages/protocol/entry/edit";
import { ReportProtocol } from "../../pages/protocol/report";
import { SchedaCalcoloCustomer } from "../../pages/schedaCalcolo/customer";
import { Notify } from "../../pages/notifiche";
import { NotifyBioEdit } from "../../pages/notifiche/biologica/edit";
import { NotifyGlobalGapEdit } from "../../pages/notifiche/globalGap/edit";
import { NotifySqnpiEdit } from "../../pages/notifiche/prodIntegrata/edit";
import { Incarichi } from "../../pages/incarichi";
import { AddAssignment } from "../../pages/incarichi/addAssignment";
import { EditAssignment } from "../../pages/incarichi/editAssignment";
import { InspectionVisitBlocksEdit } from "../../pages/incarichi/inspectionVisit/edit/blocks";
import { InspectionVisitEdit } from "../../pages/incarichi/inspectionVisit/edit";
import { ReportPersonaleContabileView } from "../../pages/gestioneAmministrazione/reportPersonaleContabile";
import { IncProformaDetails } from "../../pages/gestioneAmministrazione/reportPersonaleContabile/incDetails";
import { GestioneDemeter } from "../../pages/gestioneClienti/gestioneDemeter";
import { GestioneBiosuisse } from "../../pages/gestioneClienti/gestioneBiosuisse";
import { AddCertificazioneBiosuisse } from "../../pages/gestioneClienti/gestioneBiosuisse/addCertificazioneBiosuisse";
import { AddCertificazioneDemeter } from "../../pages/gestioneClienti/gestioneDemeter/addCertificazioneDemeter";
import { MonitoraggioRID } from "../../pages/gestioneClienti/RID/monitoraggioRid";
import { OldProtocol } from "../../pages/protocol/pre2015";
import { MonitoringFaseAvvio } from "../../pages/monitoraggi/monitoringFaseAvvio";
import { MonitoringBiosuisse } from "../../pages/gestioneClienti/gestioneBiosuisse/monitoringBiosuisse";
import { M024 } from "../../pages/gestioneControllo/m024";
import { EditM024 } from "../../pages/gestioneControllo/m024/editM024";
import { M018 } from "../../pages/gestioneControllo/m018";
import { AddNewM018 } from "../../pages/gestioneControllo/m018/add";
import { EditCertificazioneBiosuisse } from "../../pages/gestioneClienti/gestioneBiosuisse/editCertificazioneBiosuisse";
import { EditCertificazioneDemeter } from "../../pages/gestioneClienti/gestioneDemeter/editCertificazioneDemeter";
import { ReportTuttiProvvedimenti } from "../../pages/gestioneProvvedimenti/reportTuttiProvvedimenti";
import { PersonaleContabileView } from "../../pages/gestioneAmministrazione/personaleContabile";
import { PcDetailsInc } from "../../pages/gestioneAmministrazione/personaleContabile/detailsInc";
import { EditValutazioneM024 } from "../../pages/gestioneControllo/m024/editValutazione";
import { EditRiesameM024 } from "../../pages/gestioneControllo/m024/editRiesame";
import { EditDecisioneM024 } from "../../pages/gestioneControllo/m024/editDecisione";
import { MonitoringValutazioni } from "../../pages/monitoraggi/monitoringValutazioni";
import { MonitoringM24Open } from "../../pages/monitoraggi/monitoraggioM24Aperti";
import { MonitoringM24Emessi } from "../../pages/monitoraggi/monitoraggioM24Emessi";
import { MonitoringNotifiche2023 } from "../../pages/monitoraggi/monitoraggioNotifiche";
import { ReportProvvedimenti } from "../../pages/gestioneProvvedimenti/reportProvvedimenti";

const userRouter = createBrowserRouter([
    {
        path: '/',
        element: (<DashboardView />),
    },
    {
        path: '/customers',
        element: (<Clienti />)
    },
    {
        path: '/customer',
        element: (<NewCliente />)
    },
    {
        path: '/edit-customer/:id',
        element: (<EditCustomer />)
    },
    {
        path: '/gestionePersonale',
        element: (<GestionePersonale />)
    },
    {
        path: '/formazione',
        element: (<Formazione />)
    },
    {
        path: '/nuovoFormazione',
        element: (<NewTraining />)
    },
    {
        path: '/editFormazione',
        element: (<EditTraining />)
    },
    {
        path: '/nuovoPersonale',
        element: (<NewStaff />)
    },
    {
        path: '/editPm/:id',
        element: (<EditStaff />)
    },
    {
        path: '/entryProtocol',
        element: (<EntryProtocol />)
    },
    {
        path: '/departureProtocol',
        element: (<DepartureProtocol />)
    },
    {
        path: '/reportProtocol',
        element: (<ReportProtocol />)
    },
    {
        path: '/addEntryProtocol',
        element: (<AddEntryProtocol />)
    },
    {
        path: '/editEntryProtocol',
        element: (<EditEntryProtocol />)
    },
    {
        path: '/addDepartureProtocol',
        element: (<AddDepartureProtocol />)
    },
    {
        path: '/editDepartureProtocol',
        element: (<EditDepartureProtocol />)
    },
    {
        path: '/gestioneDocumenti',
        element: (<GestioneDocumenti />)
    },
    {
        path: '*',
        element: (<PageNotFound />)
    },
    {
        path: '/cartellaAziendale',
        element: (<CartellaAziendale />)
    },
    {
        path: '/segnalazioni',
        element: (<Segnalazioni />)
    },
    {
        path: '/addSegnalazione',
        element: (<AddReporting />)
    },
    {
        path: '/rid',
        element: (<RID />)
    },
    {
        path: '/addRid',
        element: (<AddRID />)
    },
    {
        path: '/editRid',
        element: (<EditRID />)
    },
    {
        path: '/liberatorie',
        element: (<Liberatorie />)
    },
    {
        path: '/editSegnalazione',
        element: (<EditReporting />)
    },
    {
        path: '/cartellaAziendale',
        element: (<CartellaAziendale />)
    },
    {
        path: '/registriAziendali',
        element: (<RegistriAziendali />)
    },
    {
        path: '/addRegistroAziendale',
        element: (<AddRegistroAziendale />)
    },
    {
        path: '/editRegistroAziendale',
        element: (<EditRegistroAziendale />)
    },
    {
        path: '/reportRegistroAziendale',
        element: (<ReportRegistriAziendali />)
    },
    {
        path: '/pac',
        element: (<PAC />)
    },
    {
        path: '/addPacDetail',
        element: (<AddPAC />)
    },
    {
        path: '/editPacDetail',
        element: (<EditPAC />)
    },
    {
        path: '/gestionePrelieviForAll',
        element: (<GestionePrelieviForAll />)
    },
    {
        path: '/complianceRequests',
        element: (<ComplianceRequests />)
    },
    {
        path: '/addComplianceRequest',
        element: (<AddComplianceRequest />)
    },
    {
        path: '/editComplianceRequest',
        element: (<EditRequestComplianceRequest />)
    },
    {
        path: '/periodoConversione',
        element: (<PeriodoConversione />)
    },
    {
        path: '/addPeriodoConversione',
        element: (<PeriodoConversioneAdd />)
    },
    {
        path: '/editPeriodoConversione',
        element: (<PeriodoConversioneEdit />)
    },
    {
        path: '/reinforcedControlMeasure',
        element: (<ReinforcedControlMeasure />)
    },
    {
        path: '/addReinforcedControlMeasure',
        element: (<AddReinforcedControlMeasure />)
    },
    {
        path: '/editReinforcedControlMeasure',
        element: (<EditReinforcedControlMeasure />)
    },
    {
        path: '/provvedimentiCliente',
        element: (<CustomerMeasueres />)
    },
    {
        path: '/editCodexMeasure',
        element: (<EditCodexMeasure />)
    },
    {
        path: '/creaProvvedimentoAltroOdc',
        element: (<AddNewCodexMeasureOtherOdc />)
    },
    {
        path: '/addNewCodexMeasureStep1',
        element: (<AddNewCodexMeasureStep1 />)
    },
    {
        path: '/addNewCodexMeasureStep2',
        element: (<AddNewCodexMeasureStep2 />)
    },
    {
        path: '/editProvvedimentoAltroOdc',
        element: (<EditCodexMeasureOtherOdc />)
    },
    {
        path: '/schedaCalcoloCustomer',
        element: (<SchedaCalcoloCustomer />)
    },
    {
        path: '/notify',
        element: (<Notify />)
    },
    {
        path: '/notifyBioEdit',
        element: (<NotifyBioEdit />)
    },
    {
        path: '/notifyGlobalGapEdit',
        element: (<NotifyGlobalGapEdit />)
    },
    {
        path: '/notifySqnpiEdit',
        element: (<NotifySqnpiEdit />)
    },
    {
        path: '/incarichi',
        element: (<Incarichi />)
    },
    {
        path: '/inserisciIncarico',
        element: (<AddAssignment />)
    },
    {
        path: '/modificaIncarico',
        element: (<EditAssignment />)
    },
    {
        path: '/ivEdit',
        element: (<InspectionVisitEdit />)
    },
    {
        path: '/reportPersonaleContabile',
        element: (<ReportPersonaleContabileView />)
    },
    {
        path: '/dettaglioPersonaleContabile',
        element: (<PcDetailsInc />)
    },
    {
        path: '/personaleContabile',
        element: (<PersonaleContabileView />)
    },
    {
        path: '/editValutazioneM024',
        element: (<EditValutazioneM024 />)
    },
    {
        path: '/editRiesameM024',
        element: (<EditRiesameM024 />)
    },
    {
        path: '/editDecisioneM024',
        element: (<EditDecisioneM024 />)
    },
    {
        path: '/proformaDetails',
        element: (<IncProformaDetails />)
    },
    {
        path: '/gestioneDemeter',
        element: (<GestioneDemeter />)
    },
    {
        path: '/gestioneBiosuisse',
        element: (<GestioneBiosuisse />)
    },
    {
        path: '/editBioSuisse',
        element: (<EditCertificazioneBiosuisse />)
    },
    {
        path: '/editDemeter',
        element: (<EditCertificazioneDemeter />)
    },

    {
        path: '/addCertificazioneBiosuisse',
        element: (<AddCertificazioneBiosuisse />)
    },
    {
        path: '/addCertificazioneDemeter',
        element: (<AddCertificazioneDemeter />)
    },
    {
        path: '/monitoraggioRid',
        element: (<MonitoraggioRID />)
    },
    {
        path: '/protocolloPre2015',
        element: (<OldProtocol />)
    },
    {
        path: '/monitoringFaseAvvio',
        element: (<MonitoringFaseAvvio />)
    },
    {
        path: '/monitoringBioSuisse',
        element: (<MonitoringBiosuisse />)
    },
    {
        path: '/listM024',
        element: (<M024 />)
    },
    {
        path: '/editM024',
        element: (<EditM024 />)
    },
    {
        path: '/customerM018',
        element: (<M018 />)
    },
    {
        path: '/AddNewM018',
        element: (<AddNewM018 />)
    },
    {
        path: '/elencoCompletoProvvedimenti',
        element: (<ReportTuttiProvvedimenti />)
    },
    {
        path: '/monitoraggioValutazioni',
        element: (<MonitoringValutazioni />)
    },
    {
        path: '/monitoraggioM24Aperti',
        element: (<MonitoringM24Open />)
    },
    {
        path: '/monitoraggioM24Emessi',
        element: (<MonitoringM24Emessi />)
    },
    {
        path: '/monitoraggioNotifiche2023',
        element: (<MonitoringNotifiche2023 />)
    },
    {
        path: '/reportProvvedimenti',
        element: (<ReportProvvedimenti />)
    },


])

export default userRouter;